module.exports = __webpack_public_path__ + "img/shocked.122ce5af.svg";